import { render, staticRenderFns } from "./clip-loader.vue?vue&type=template&id=2c4a6962&"
import script from "./clip-loader.vue?vue&type=script&lang=js&"
export * from "./clip-loader.vue?vue&type=script&lang=js&"
import style0 from "./clip-loader.vue?vue&type=style&index=0&id=2c4a6962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports